import { AxiosResponse } from 'axios';
import httpClient from '../clients/httpClient';
import SignageItem from '../types/contracts/responses/SignageItem';
import { toast } from 'react-toastify';

class SignageItemService {
    baseUri: string = "/v1/SignageItems";

    displayError = (e: any) => {
        if (e.response?.data?.message && e.response.status !== 500) {
            const data = e.response.data;
            let errorMessage = `${data.message}\n`;

            for (const key in data.details) {
              if (data.details.hasOwnProperty(key)) {
                const fieldErrors = data.details[key];
                errorMessage += `${key}: ${fieldErrors.join(', ')}\n`;
              }
            }

            toast.error(errorMessage);
        }
        else {
            toast.error("Serverio klaida. Prašome bandyti vėliau.", {
                toastId: "serverError"
            });
        }
    }

    async getAll(): Promise<SignageItem[] | null> {
        try {
            const response: AxiosResponse = await httpClient.get(`${this.baseUri}`);
            const signageItemList: SignageItem[] = response.data;

            return signageItemList;
        }
        catch (e: any) {
            this.displayError(e);
        }

        return null;
    }
}

const newSignageItemService = new SignageItemService();
export default newSignageItemService;
